import {
  isClientIdValid,
  isSecretKeyValid,
  isUuidValid
} from '../../shared/CredentialsFields/helpers';

export interface OverrideCredentials {
  accountUuid: string;
  clientId: string;
  secretKey: string;
}

export type OverrideCredentialField = keyof OverrideCredentials;

export const initialOverrideCredentials: OverrideCredentials = {
  accountUuid: '',
  clientId: '',
  secretKey: ''
};

export const isOverrideCredentialsValid = (
  values: OverrideCredentials
): boolean =>
  isUuidValid(values.accountUuid) &&
  isClientIdValid(values.clientId) &&
  isSecretKeyValid(values.secretKey);

export const trimOverrideCredentials = (
  values: OverrideCredentials
): OverrideCredentials => ({
  accountUuid: values.accountUuid.trim(),
  clientId: values.clientId.trim(),
  secretKey: values.secretKey.trim()
});
